import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFastForward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFastForward"><Path d="M4 3.98242V20.0178L12 13.9002V20.0178L22.4847 12.0001L12 3.98242V10.1001L4 3.98242Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFastForward;
